import apiFetch from '../apiFetch'

export default function (idDireccionCliente) {
  return apiFetch({endPoint: `Combos/getComboTransportistasCliente?idDireccionCliente=${idDireccionCliente}`, method: 'GET', body: null})
}